import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
  padding: 2.7em;
  background-color:#000000;

  @media all and (max-width:${variables.mobileL}) {
    padding: 2.7em 1.5em;
  }
`;